import React from 'react';
import { Select, Form, Flex } from 'antd';
import SyncIndicator from './SyncIndicator';

const MultiselectField = ({ field, values = [], onChange, disabled }) => {
	return (
		<Form.Item style={{ marginBottom: 8 }}>
			<Flex gap={8}>
				<Select
					mode="multiple"
					value={values}
					onChange={(vals) => onChange(vals)}
					placeholder="Выберите значения"
					style={{ width: '40%', minWidth: '200px' }}
					allowClear
					onClear={() => onChange([])}
					disabled={disabled}
				>
					{field.options?.map(option => (
						<Select.Option key={option.id} value={option.value}>
							{option.value}
						</Select.Option>
					))}
				</Select>
				<div style={{ lineHeight: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
					{field.name}
					<SyncIndicator field={field} />
				</div>
			</Flex>
		</Form.Item>
	);
};

export default MultiselectField; 